import { Navigate, type RouteObject } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { lazyPage } from './lazyPage'
import { LegacyProfileRedirect } from './LegacyRedirects'

/** Placeholder for a page that is still being rebuilt in the new UI. */
function comingSoon(title: string) {
  return lazyPage(() => import('@/pages/ComingSoonPage'), { title })
}

/**
 * Every signed-in route, rendered inside the AppShell (sidebar + top bar). Each module branch swaps
 * its placeholder for the real page; legacy portal URLs redirect so old bookmarks and emails keep working.
 */
export const workspaceRoutes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      { path: '/', element: comingSoon('Production board') },

      // ----- People: customers -----
      { path: '/customers', element: lazyPage(() => import('@/pages/people/CustomersPage')) },
      { path: '/customers/:userId', element: lazyPage(() => import('@/pages/people/CustomerDetailsPage')) },
      { path: '/customer/:userId/profile', element: <LegacyProfileRedirect kind="customer" /> },

      // ----- People: team -----
      { path: '/team', element: lazyPage(() => import('@/pages/people/TeamPage')) },
      { path: '/team/:userId', element: lazyPage(() => import('@/pages/people/TeamMemberPage')) },
      { path: '/users', element: <Navigate to="/team" replace /> },
      { path: '/user/:userId/profile', element: <LegacyProfileRedirect kind="team" /> },

      // ----- Account -----
      // `/profile` must exist because RequireAuth sends incomplete accounts there.
      { path: '/profile', element: lazyPage(() => import('@/pages/workspace/ProfilePage')) },

      { path: '*', element: comingSoon('This page') },
    ],
  },
]
